var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.1185 5.68575C3.4935 5.41275 3.96375 5.25 4.473 5.25H19.527C20.0363 5.25 20.5065 5.41275 20.8815 5.68575L12 11.8942C12 11.8942 4.94175 6.96075 3.1185 5.68575ZM21.696 6.89325C21.7313 7.0425 21.75 7.197 21.75 7.356V16.644C21.75 17.8073 20.7548 18.75 19.527 18.75H4.473C3.24525 18.75 2.25 17.8073 2.25 16.644V7.356C2.25 7.197 2.26875 7.0425 2.304 6.89325L11.5575 13.362C11.8208 13.5457 12.1792 13.5457 12.4425 13.362L21.696 6.89325Z",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailicon);
export default __webpack_public_path__ + "static/media/mail icon.ae1b8bb4d4f505f3434a02d26a9f09ba.svg";
export { ForwardRef as ReactComponent };